import axios from 'axios';

export interface S3Creds {
    url: string;
    key: string;
    fields: {
        key: string;
        bucket: string;
        Policy: string;
        'Content-Type': string;
        'X-Amz-Algorithm': string;
        'X-Amz-Credential': string;
        'X-Amz-Date': string;
        'X-Amz-Security-Token': string;
        'X-Amz-Signature': string;
    };
}
export async function postToS3(creds: S3Creds, file: File, signal?: AbortSignal): Promise<boolean> {
    const body = new FormData();
    Object.entries(creds.fields).forEach(([k, v]) => body.append(k, v as string));
    body.append('file', file);

    const res = await axios.post(creds.url, body, {
        signal,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    return res.status === 204 || res.data === '';
}

export function formatS3Url(dnsUrl: string, originalUrl: string, encode: boolean = false) {
    const url = originalUrl.split('/').slice(3).join('/');
    const encoded = encode ? encodeURIComponent(url) : url;

    return `${dnsUrl}/${encoded}`;
}
